import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CartItem } from "../modules/stores/interfaces/CartItem";
import { CartState } from "../modules/stores/interfaces/CartState";

const initialState: CartState = {
    items: [],
    orderNotes: "",
};

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        addProduct: (state, action: PayloadAction<CartItem>) => {
            const existing = state.items.find(item => item.productId === action.payload.productId);
            if (existing) {
                Object.assign(existing, action.payload);
            } else {
                state.items.push(action.payload);
            }
        },
        removeProduct: (state, action: PayloadAction<number | string>) => {
            state.items = state.items.filter(item => item.productId !== action.payload);
        },
        updateQuantity: (state, action: PayloadAction<{ id: number | string; quantity: number }>) => {
            const item = state.items.find(i => i.productId === action.payload.id);
            if (item) item.quantity = action.payload.quantity;
        },
        updateProductNotes: (state, action: PayloadAction<{ productId: number | string; productNotes: string }>) => {
            const item = state.items.find(i => i.productId === action.payload.productId);
            if (item) item.productNotes = action.payload.productNotes || undefined;
        },
        setOrderNotes: (state, action: PayloadAction<string>) => {
            state.orderNotes = action.payload ?? "";
        },
        clearCart: (state) => {
            state.items = [];
            state.orderNotes = "";
        },
        setCartItems: (state, action: PayloadAction<CartItem[]>) => {
            state.items = action.payload;
        },
    },
});

export const { addProduct, removeProduct, updateQuantity, updateProductNotes, setOrderNotes, clearCart, setCartItems } = cartSlice.actions;
export type { CartItem } from "../modules/stores/interfaces/CartItem";
export default cartSlice.reducer;
